import {
  Button,
  FormControl,
  FormLabel,
  Input,
  InputGroup,
  InputRightElement,
  position,
  Toast,
  VStack,
  Text,
} from "@chakra-ui/react";
import React, { useState } from "react";
import { useToast } from "@chakra-ui/react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { ChatState } from "../../Context/ChatProvider";

const Login = ({ onForgotPassword }) => {
  const [show, setShow] = useState(false);
  const [email, setEmail] = useState();
  const [password, setPassword] = useState();
  const [loading, setLoading] = useState(false);

  const toast = useToast();
  const navigate = useNavigate();
  const { setUser } = ChatState();
  const handleClick = () => setShow(!show);

  const submitHandler = async () => {
    setLoading(true);
    if (!email || !password) {
      toast({
        title: "Please enter Email and Password",
        status: "warning",
        duration: 5000,
        isClosable: true,
        position: "bottom",
      });
      setLoading(false);
      return;
    }

    try {
      const config = {
        headers: {
          "Content-type": "application/json",
        },
      };

      const { data } = await axios.post(
        "/api/user/login",
        { email, password },
        config
      );

      // Store only the token
      localStorage.setItem("authToken", data.token);

      // Fetch user data using the token
      const userConfig = {
        headers: {
          Authorization: `Bearer ${data.token}`,
        },
      };

      const { data: userData } = await axios.get("/api/user/me", userConfig);

      toast({
        title: "Login Successful",
        status: "success",
        duration: 5000,
        isClosable: true,
        position: "bottom",
      });

      setUser(userData); // Update context with verified user data
      setLoading(false);

      // Check vendor approval status
      if (userData.role === "vendor") {
        if (userData.isApproved === "pending") {
          navigate("/vendor-pending");
        } else if (userData.isApproved === "rejected") {
          navigate("/vendor-rejected");
        } else if (userData.isApproved === "approved") {
          navigate("/chats");
        }
      } else {
        navigate("/chats");
      }
    } catch (error) {
      const message = error.response
        ? error.response.data.message
        : error.message;
      toast({
        title: "Error Occured!",
        description: message,
        status: "error",
        duration: 5000,
        isClosable: true,
        position: "bottom",
      });
      setLoading(false);
    }
  };

  return (
    <VStack spacing="5px" color="black">
      <FormControl id="email" isRequired>
        <FormLabel>Email:</FormLabel>
        <Input
          placeholder="Enter Your Email"
          onChange={(e) => setEmail(e.target.value)}
        />
      </FormControl>

      <FormControl id="password" isRequired>
        <FormLabel>Password:</FormLabel>
        <InputGroup>
          <Input
            type={show ? "text" : "password"}
            placeholder="Enter Your Password"
            onChange={(e) => setPassword(e.target.value)}
          />
          <InputRightElement width="4.5rem">
            <Button h="1.75rem" size="sm" onClick={handleClick}>
              {show ? "Hide" : "Show"}
            </Button>
          </InputRightElement>
        </InputGroup>
      </FormControl>

      <Button
        colorScheme="orange"
        width="100%"
        style={{ marginTop: 15 }}
        onClick={submitHandler}
        isLoading={loading}
      >
        Login
      </Button>

      <Text
        fontSize="sm"
        color="blue.500"
        cursor="pointer"
        textAlign="center"
        mt={2}
        onClick={onForgotPassword}
        _hover={{ textDecoration: "underline" }}
      >
        Forgot Password?
      </Text>
    </VStack>
  );
};

export default Login;
